<template>
  <div v-html="apply">
    {{apply}}
  </div>
</template>

<script>
export default {
    name: "applyText",
    data() {
        return {
            apply: ''
        }
    },
    mounted() {
        this.success(this.$route.query.code)
    },
    methods: {
        async success(code){
            if (200 == code){
                alert("首次支付认证成功,请重新扫码支付")
            } else{
                alert("首次支付认证失败")
            }
            WeixinJSBridge.call('closeWindow');
        }
    }
}
</script>

<style scoped>
</style>